import { render, staticRenderFns } from "./TabContacts.vue?vue&type=template&id=e27f361a&"
import script from "./TabContacts.vue?vue&type=script&lang=js&"
export * from "./TabContacts.vue?vue&type=script&lang=js&"
import style0 from "./TabContacts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports